export interface AgencyData {
  id: string;
  name: string;
  email_domain: string;
  kind: string;
  contact_email?: string;
  state?: string | null;
  contact_phone?: string | null;
}

export interface AgencyOfficialType {
  id: number;
  name: string;
  agency_id: number;
}

export interface AgencyOfficialRole {
  id: number;
  name: string;
  description: string;
}

export interface FeatureFlag {
  id: number;
  flag_name: string;
  enabled: boolean;
}

export interface Agency {
  id: number | string;
  name: string;
  logo_url?: string;
  groups?: AgencyGroup[];
  agency_official_types?: AgencyOfficialType[];
  roles?: AgencyOfficialRole[];
  feature_flags?: FeatureFlag[];
  universal_feature_flags?: FeatureFlag[];
  contact_email?: string;
  kind?: string;
  email_domain?: string;
  state?: string | null;
  contact_phone?: string | null;
}

export const AgencyQuestionKind = {
  OFFICIAL_CAPACITY: 'official_capacity'
};

export interface AgencyQuestion {
  id: string;
  question: string;
  description: string | null;
  kind: string | null;
  created_at: string;
}

export interface AgencyGroup {
  id: number;
  name: string;
  default: boolean;
  agency_id: number;
}

export interface AgencyRole {
  id: number;
  name: string;
}

export interface DropzoneFile extends File {
  path?: string;
}

export type PreviewDropzoneFile = DropzoneFile & { preview: string };

export type Dict<T> = {
  [key: string]: T
};

export interface NewOfficialData {
  first_name: string;
  last_name: string;
  title: string;
  rank: string;
  badge_number: string;
  agency_name: string;
  email: string;
  phone_number: string;
  post_id: string;
  acknowledgementChecked: boolean;
}

export type NewOfficialWithToken = {
  agency_official: NewOfficialData & {
    google_recaptcha_token?: string | undefined,
    promo_name?: string;
  };
};